import React from "react";
import {
	Button,
	ClassNameProps,
	Conditional,
	Else,
	Grid,
	Heading,
	If,
	Modal,
	Row,
	Section,
	StyleProps,
} from "@hex-insights/core";
import { SlimEmptyView } from "../../../../Components/Empty";
import { Icon, IconContainer } from "../../../../Components/Icon";
import { Person, PersonNameFragment } from "../../../../Utilities";
import { CardEmailAddress, EmailAddressCard } from "../Card";
import { EmailAddressPersonListModal } from "../PersonListModal";
import styles from "./styles.module.css";

export type EmailAddressPersonListSectionProps = {
	person: Pick<Person, "id"> & PersonNameFragment;
	emailAddresses: CardEmailAddress[];
	columns?: number;
} & Partial<ClassNameProps & StyleProps>;

export function EmailAddressPersonListSection({
	person,
	emailAddresses,
	columns = 1,
	className,
	style,
}: EmailAddressPersonListSectionProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Section className={className} style={style}>
				<Section.Header>
					<Row justify="space-between" align="center">
						<Row justify="spaced-start" align="center">
							<IconContainer color="var(--theme-colors__blue--light)">
								<Icon.EnvelopeSimple color="var(--theme-colors__blue)" size={18} />
							</IconContainer>

							<Heading.H3 noMargin>Email Addresses</Heading.H3>
						</Row>

						<Button variant="link" size="small" onClick={openModal} className="button--icon">
							<Icon.Gear size={16} className="block" />
						</Button>
					</Row>
				</Section.Header>
				<Section.Body className={styles["body"]}>
					<Conditional>
						<If condition={emailAddresses.length === 0}>
							<SlimEmptyView>No email addresses listed</SlimEmptyView>
						</If>
						<Else>
							<Grid
								tracks={columns}
								gap="var(--general--spaced---vertical-spacing) var(--general--spaced---horizontal-spacing)"
							>
								{emailAddresses.map((emailAddress) => (
									<EmailAddressCard key={emailAddress.id} emailAddress={emailAddress} slim />
								))}
							</Grid>
						</Else>
					</Conditional>
				</Section.Body>
			</Section>

			<Modal.If condition={isModalOpen}>
				<EmailAddressPersonListModal person={person} emailAddresses={emailAddresses} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}
